// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"d2afa6d1","108":"88a04954","135":"88a04954","439":"658c7f74","491":"05e02ec0","640":"8c8d0e7a","774":"707c9371","842":"e394e561"}[chunkId] + ".css";
};